/*
 * File: router.js
 * Project: <<marketing-system>>
 * File Created: 2018-8-21 11:51:4 AM
 * Author: xiongyang (yang.xiong@meicloud.com)
 * -----
 * Last Modified: 2018-05-14 8:02:02 pm
 * Modified By: xiongyang (yang.xiong@meicloud.com>) (<<git>>)
 * -----
 * Copyright © 2018 - MeiCloud, MeiCloud
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes/index';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css';// Progress 进度条样式
import store from '../store';
import { getSession, getCookieValue } from '@/utils';

import addRouterAuth from '@/router/addRouterAuth.js';
// 一些其它自定义方法
import { clearBrother, fromDcpToMeiju, everyUpdateRoute, noAuthMessage } from './routerEvent';

// 重镜像次数
var redirectNum = 0;

// 使用路由组件
Vue.use(VueRouter);

// 创建路由
const router = new VueRouter({
  // mode: 'history',    // 路由的模式
  // base: __dirname,
  scrollBehavior: (to) => {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: routes
});

router.beforeEach((to, from, next) => {
  NProgress.start(); // 开启Progress
  console.log('我现在的路由是：', from, '我要跳去的路由是：', to, '重镜像次数：', redirectNum);
  // 页面title
  document.title = to.meta.label || '用户运营平台';

  // 如果不是父子&&兄弟页面，跳转页面时清除查询条件
  clearBrother(to, from);

  // 当前路径
  var newLocalHref = window.location.href;
  // 链接中是否带参数表明是否从美居以及单点登录跳转过来的
  let c4asys = '';
  if (to && to.query && to.query.isFromC4a) {
    c4asys = to.query.isFromC4a;
  }

  console.log('页面路径校验', newLocalHref, c4asys);
  // 做权限控制，是否登录
  console.log(to, store.getters['user/user'], getSession('user'), '如果单点登录了其它用户，这里的账号要切换成其它用户:', 
  getCookieValue('cmms2_token'), getSession('cmms2Token'), 
  (getSession('cmms2Token') && getSession('cmms2Token') === getCookieValue('cmms2_token')),
  '是否有重镜像路由：', !to.redirectedFrom);
  // debugger;
  if (
    (
      (store.getters['user/user'] && !(getSession('cmms2Token') &&
        (getSession('cmms2Token') === getCookieValue('cmms2_token')))) ||
        !getSession('user')
    ) &&
      (to.path.indexOf('login') === -1 && to.path.indexOf('entrance') === -1 && !to.redirectedFrom)
  ) {
    // 如果单点登录了其它用户，这里的账号要切换成其它用户
    // 或者用户信息不存在的时候，重新请求权限
    // 除了开发环境：清空缓存，重置权限
    // 暂时注释，开发用 begin
    // if (process.env.ENV_CONFIG !== 'dev') {
    //   store.dispatch('user/logoutClearUserInfo');
    //   setSession('authMenuList', null);
    // }
    // 暂时注释，开发用 end

    // 添加权限菜单
    console.log('我是 走正常的登录', store.getters['user/user'], getSession('user'), !getSession('user'), '这里清空用户所有权限缓存111');
    // debugger;
    addRouterAuth({
      callback: () => {
        store.dispatch('user/flagGetAuthList', false);
        next();
      }
    }, false, null, 1);

    // 重镜像次数
    redirectNum = 0;
  } else if (c4asys === 'meiju') {
    // 从dcp 登录后，直接从dep跳转去美居页面，先去后端拿 cookie
    // 然后就去单点登录获取登录信息
    fromDcpToMeiju();

    // 重镜像次数
    redirectNum = 0;
  } else if (getCookieValue('cmms2_token') && !store.getters['user/user'] &&
  to.path.indexOf('login') === -1 && to.path.indexOf('entrance') === -1) {
    // 单点登录
    // console.log('我是 走单点登录  但是不确定能不能登录', to);
    // debugger;
    addRouterAuth({
      callback: (url) => {
        store.dispatch('user/flagGetAuthList', false);
        console.log(url, '要跳转去的地址');
        // debugger;
        if (url && redirectNum < 3) {
          next({ path: url });
          // 重镜像次数
          redirectNum++;
        } else {
          next();
          // 重镜像次数
          redirectNum = 0;
        }
      }
    }, true, to, 7);
  } else if (to.matched.length === 0 && to.path.indexOf('login') === -1 && to.path.indexOf('entrance') === -1) {
    // 如果未匹配到路由 一般是没有权限就匹配不了
    console.log('如果未匹配到路由 一般是没有权限就匹配不了 跳去首页');
    // 没有权限的提示
    noAuthMessage(to);
    // debugger;
    // 如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
    next({ name: 'home' });
  } else {
    console.log('这里是正常的走路由');
    // debugger;
    next();
    // 重镜像次数
    redirectNum++;
  }

  // 每次更新路由都要执行的操作,但是不影响流程
  everyUpdateRoute(to);

});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});

// 预防 Loading chunk {n} failed 的报错
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
